import React from 'react';

import {Text} from './uiElem';

const colors = {
  green: {
    background: 'bg-green-lightest-alpha',
    icon: 'text-green',
  },
  purple: {
    background: 'bg-purple-lightest',
    icon: 'text-purple',
  },
  grey: {
    background: 'bg-grey-4',
    icon: 'text-grey-1',
  },
};

function DisplayBoxSmaller({
  border = true,
  color = 'grey',
  currentNr,
  description,
  fullWidth = false,
  icon,
  isCurrentBox,
  onClick,
}) {
  const content = (
    <div className={`flex items-center`}>
      <div
        className={`${colors[color].background} flex flex-shrink-0 rounded-full text-center items-center justify-center w-8 h-8 mx-2 my-1 sm:w-12 sm:h-12 sm:mx-3 sm:my-2`}>
        {!!icon && <div className={`${colors[color].icon}`}>{icon}</div>}
      </div>

      <div className={`${colors[color].icon}`}>
        <Text>
          <p className={`leading-none pr-2 ${isCurrentBox ? 'text-pink' : ''}`}>
            {currentNr}. {description}
          </p>
        </Text>
      </div>
    </div>
  );

  const boxClasses = `${fullWidth ? 'block' : ''} ${
    border ? 'border border-solid border-grey bg-white rounded' : ''
  }`;

  if (onClick) {
    return (
      <button className={boxClasses} onClick={onClick}>
        {content}
      </button>
    );
  }

  return <div className={boxClasses}>{content}</div>;
}

export default DisplayBoxSmaller;
